import React from 'react';
import styled from 'styled-components';
import { number, string } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { format } from '@olxbr/mojo-jojo/utils/string';

const Container = styled.div`
  text-align: center;
  strong{ font-weight: bold }
  font-size: 14px;
  line-height: 1.4;
  color: #4A4A4A;
  @media(min-width:1000px) {
    font-size : 20px;
  }
`;

const Consumption = ({
  consumption, categoryName, dueDate, text,
}) => (
  <Container>
    <ReactMarkdown source={format(text, { consumption, categoryName, dueDate })} />
  </Container>
);

Consumption.propTypes = {
  consumption: number.isRequired,
  categoryName: string.isRequired,
  dueDate: string.isRequired,
  text: string.isRequired,
};

export default Consumption;
